import type { QuestionForClient, SubmitGameRequest, SubmitGameResponse } from '@beast-keeper/shared';
import { api } from './api';

/** 获取一局题目 */
export async function fetchSessionQuestions(): Promise<QuestionForClient[]> {
  const res = await api.post('/games/session');
  return res.data.questions;
}

/** 提交答题结果 */
export async function submitGameResult(data: SubmitGameRequest): Promise<SubmitGameResponse> {
  const res = await api.post('/games/submit', data);
  return res.data;
}
